module.exports = __webpack_public_path__ + "img/Butterfly_00198.96131f90.png";